import {
  HumanizeDurationLanguage,
  HumanizeDuration,
} from "humanize-duration-ts";

const langService: HumanizeDurationLanguage = new HumanizeDurationLanguage();
export const humaniser: HumanizeDuration = new HumanizeDuration(langService);
